export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";
export const REMOVE_ACCESS_TOKEN = "REMOVE_ACCESS_TOKEN";
export const SET_PROGRESS = "SET_PROGRESS";
export const SET_RECOVER_PASSWORD = "SET_RECOVER_PASSWORD";
export const ADD_TOKEN = "ADD_TOKEN";
export const SET_WORKSPACES = "SET_WORKSPACES";
export const RESET_PASSWORD = "RESET_PASSWORD";
